import ComponentsFactory from 'foundation/components-factory';
import EndeavorPlaylistComponent from './js/endeavor-playlist-component';
import './scss/index.scss';

ComponentsFactory.getInstance().define('endeavor-playlist', EndeavorPlaylistComponent);
